const FAKE_METAL_PRICE = true;
const FAKE_METAL_PRICE_LIST = ['platinum', 'gold-18k', 'gold-14k', 'gold-10k-white', 'gold-10k-yellow', 'gold-9k']
const FAKE_COMPARE_PRICE_PERCENTAGE = 40;
const FAKE_ALL_METAL_PRICE = true;


const Product = {
  log: window.log,

  init() {
    this.calculateDeliveryDate(1);
    this.variantSelector();
    this.boldMembershipsSelector();
    this.initUpdate();
    this.addToCart();
    this.startPriceFluctuation();
    this.engraving();
  },

  calculateDeliveryDate(daysToAdd) {
    const currentDate = new Date();
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const addBusinessDays = (startDate, numDays) => {
      const resultDate = new Date(startDate);
      let addedDays = 0;
      while (addedDays < numDays) {
        resultDate.setDate(resultDate.getDate() + 1);
        if (resultDate.getDay() !== 0 && resultDate.getDay() !== 6) {
          addedDays++;
        }
      }
      return resultDate;
    };

    const firstDeliveryDate = addBusinessDays(currentDate, daysToAdd);
    const formattedDate = `${days[firstDeliveryDate.getDay()]}, ${firstDeliveryDate.getDate()} ${months[firstDeliveryDate.getMonth()]}`;
    $('.pdp-main__product-delivery .delivery_date').text(formattedDate);
  },

  boldMemberships: $('body').data('bold-memberships'),
  customerIsVIP: $('body').data('customer-is-vip'),
  productType: $('#variants-data').data('product-type').trim(),
  clothingMaterial: this.productType === 'Clothing' ? $('#variants-data').data('clothing-material').trim() : '',
  currency: $('#variants-data').data('currency').match(/[^\d.,\s]+/g)?.[0] || '£',
  exchangeRates: $('#variants-data').data('exchange-rates') || { conversion_rates: { USD: 1.3495 } },
  metalPrices: $('#metal-prices').length ? {
    gold: JSON.parse($('#metal-prices').val())['gold_price_24k'],
    platinum: JSON.parse($('#metal-prices').val())['platinum_price']
  } : null,
  metal: $('.pdp-main__product-option.metal.active').data('metal'),
  size: $('.pdp-main__product-option.size.active').data('size') || $('.pdp-main__product-dropdown').val() || $('.pdp-main__product-options-dropdown__item[data-selected="true"]').data('size'),
  klarna: $('.pdp-main__klarna span'),
  previousPrices: {
    compare: 0,
    current: 0,
    metal: 0,
    storeFee: 0,
    saveAmount: 0,
    manufacturingCost: 0,
    ukVAT: 0
  },
  priceUpdateInterval: null,
  isUK: () => $('#customer-country').val() === 'GB',
  /**
   * Dynamically builds cost breakdowns from theme settings or inline data-attributes.
   * - UK and All values are injected from theme settings (using hidden inputs or data- attributes in theme for SSR/OS2.0).
   * - noFeeUk/noFeeAll are calculated on the fly from UK/All by subtracting storeFee, 
   *   and distributing its share proportionally to metal and manufacturingCost, and increasing VAT as theme formula.
   */
  get breakdownPercentages() {
    // Fetch values from hidden fields set by Liquid via theme settings
    const getFromInputs = (prefix) => ({
      metal: Number($(`#${prefix}-metal-percentage`).val()) / 100,
      manufacturingCost: Number($(`#${prefix}-manufacturing-cost-percentage`).val()) / 100,
      storeFee: Number($(`#${prefix}-store-fee-percentage`).val()) / 100,
      vat: Number($(`#${prefix}-vat-percentage`).val()) / 100
    });

    const uk = getFromInputs('price-breakdown-uk');
    const all = getFromInputs('price-breakdown');

    // Calculate no-fee variants: set storeFee to 0 and re-allocate its percentage to other keys
    // For this example, re-allocate storeFee proportionally between metal and manufacturingCost
    const adjustNoFee = (obj) => {
      const { metal, manufacturingCost, storeFee, vat } = obj;
      const noFeeStoreFee = 0;
      // Determine how much of storeFee gets reallocated (for example, split proportional to weights)
      const total = metal + manufacturingCost;
      const metalShare = total ? metal / total : 0.5;
      const mfgShare = total ? manufacturingCost / total : 0.5;
      // Increase VAT as in your original values or keep same (customize as needed)
      // Example: Keep vat at original or add a percentage of storeFee to vat
      const newVat = vat + (typeof obj.noFeeVatShare === 'number' ? obj.noFeeVatShare : (storeFee * 0.165)); // e.g. 16.5% of storeFee to VAT

      return {
        metal: +(metal + storeFee * metalShare).toFixed(4),
        manufacturingCost: +(manufacturingCost + storeFee * mfgShare).toFixed(4),
        storeFee: noFeeStoreFee,
        vat: +newVat.toFixed(4)
      };
    };

    const noFeeUk = adjustNoFee(uk);
    const noFeeAll = adjustNoFee(all);

    return {
      uk,
      all,
      noFeeUk,
      noFeeAll
    };
  },

  getLabel(group) {
    return group === 'metal'
      ? $('.pdp-main__product-option.metal.active h4').text()
      : $('.pdp-main__product-option.size.active').text() || $('.pdp-main__product-options-dropdown option:selected').text() || $('.pdp-main__product-options-dropdown__item[data-selected="true"]').find('.item-label').text().trim();
  },
  updateLabel(group) {
    $(`.pdp-main__product-options-label.${group} span`).text(this.getLabel(group));
  },

  get selectedVar() {
    const baseQuery = '#variants-data .variant-data';
    const query = baseQuery + (this.productType === 'Clothing'
      ? `${this.size ? `[data-metal="${this.size}"]` : ''}`
      : `[data-metal="${this.metal}"]${this.size ? `[data-size="${this.size}"]` : ''}`
    );

    const selected = $(query);
    window.product_selected_variant = selected.length ? selected : $(baseQuery);
    return selected.length ? selected : $(baseQuery);
  },

  startPriceFluctuation() {
    // Clear any existing interval
    if (this.priceUpdateInterval) {
      clearInterval(this.priceUpdateInterval);
    }

    // Start new interval
    this.updatePriceClasses(this.getPriceElements(), this.metal === 'gold-24k' ? 1 : 0);
    this.priceUpdateInterval = setInterval(() => {
      this.updateFluctuatedPrices();
    }, 5000);
  },

  updateFluctuatedPrices() {
    if (!this.metalPrices) {
      this.managePriceFluctuation(false);
      return;
    }

    const selectedVar = this.selectedVar;
    if (!selectedVar.length) return;

    const metal = selectedVar.data('metal');
    if (metal !== 'gold-24k' || !this.shouldShowPriceBreakdown()) { // TODO: Platinum check removed
      this.managePriceFluctuation(false);
      return;
    }

    const currentMetalPrice = this.fluctuateMetalPrice(this.getMetalPrice(metal));
    if (!currentMetalPrice) {
      this.managePriceFluctuation(false);
      return;
    }

    const weight = selectedVar.data('weight');
    const originalPrice = (selectedVar.data('price') / 100).toFixed(2);
    const priceChange = (currentMetalPrice - this.previousPrices.metal) / this.previousPrices.metal;

    // Calculate new prices based on metal type
    let newComparePrice, newDiscountedPrice, mainNewDiscountedPrice;
    if (FAKE_ALL_METAL_PRICE) {
      newDiscountedPrice = (originalPrice * (1 + priceChange)).toFixed(2);
      newComparePrice = (newDiscountedPrice * (1 + FAKE_COMPARE_PRICE_PERCENTAGE / 100)).toFixed(2); // Add 12% to get compare price

      if (this.boldMemberships && metal === 'gold-24k') {
        const membershipDiscountPercentage = selectedVar.data('membership-discount-percentage');
        vipDiscountedPrice = (newDiscountedPrice - (newDiscountedPrice * membershipDiscountPercentage / 100)).toFixed(2);

        this.updateMembershipSelectorPriceDisplay(vipDiscountedPrice, newDiscountedPrice);
        if (this.customerIsVIP) {
          $('.pdp-main__prices:not(.pdp-upsell__item-prices) :is(span:has(s), p)').removeClass('hidden');
          mainNewDiscountedPrice = newComparePrice = newDiscountedPrice;
          newDiscountedPrice = vipDiscountedPrice;
        }
      }
    } else if (metal === 'platinum' || metal === 'gold-24k') {
      // For platinum and 24k gold, the price is already discounted
      newDiscountedPrice = (originalPrice * (1 + priceChange)).toFixed(2);
      newComparePrice = (newDiscountedPrice * (1 + FAKE_COMPARE_PRICE_PERCENTAGE / 100)).toFixed(2); // Add 12% to get compare price
    } else {
      // For other metals, apply 30% discount
      newComparePrice = (originalPrice * (1 + priceChange)).toFixed(2);
      newDiscountedPrice = (newComparePrice - (newComparePrice * 0.3)).toFixed(2);
    }

    const newSaveAmount = (newComparePrice - newDiscountedPrice).toFixed(2);

    // Update main price display before resetting discountedPrice from VIP discount
    this.updateMainPriceDisplay(newComparePrice, newDiscountedPrice, newSaveAmount);
    // Reset discountedPrice from VIP display
    if (this.boldMemberships && this.customerIsVIP && metal === 'gold-24k') {
      newDiscountedPrice = mainNewDiscountedPrice;
    }

    const fees = this.isUK() ? this.breakdownPercentages.uk : this.breakdownPercentages.all;

    // Calculate net price and VAT
    // const newNetPrice = (newDiscountedPrice / (1 + fees.vat)).toFixed(2);
    // const newVatAmount = (newDiscountedPrice - newNetPrice).toFixed(2);
    const newVatAmount = (newDiscountedPrice * fees.vat).toFixed(2);

    // Calculate breakdown components
    const metalValue = (newDiscountedPrice * fees.metal).toFixed(2);
    const newManufacturingCost = (newDiscountedPrice * fees.manufacturingCost).toFixed(2);
    const newStoreFee = (newDiscountedPrice * fees.storeFee).toFixed(2);

    log.collapse({
      'fees': fees,
      'boldMemberships': this.boldMemberships,
      'customerIsVIP': this.customerIsVIP,
      'metalValue': { value: metalValue, percentage: fees.metal },
      'manufacturingCost': { value: newManufacturingCost, percentage: fees.manufacturingCost },
      'storeFee': { value: newStoreFee, percentage: fees.storeFee },
      'vat': { value: newVatAmount, percentage: fees.vat },
      'newDiscountedPrice': { value: newDiscountedPrice, percentage: 100 },
      'newComparePrice': { value: newComparePrice, percentage: 140 },
      'total': { value: +newDiscountedPrice - (+metalValue + +newVatAmount + +newStoreFee + +newManufacturingCost), percentage: 100 - (fees.metal + fees.manufacturingCost + fees.storeFee + fees.vat) }
    }, 'Fluctuated Values', 'warning');

    this.updatePriceBreakdownValues(metalValue, newStoreFee, newSaveAmount, weight, newManufacturingCost, newVatAmount);
    this.updatePriceClasses(this.getPriceElements(), priceChange);
    this.storePricesForComparison(newComparePrice, newDiscountedPrice, currentMetalPrice, newStoreFee, newSaveAmount, newManufacturingCost, newVatAmount);
  },

  // Helper function to manage price fluctuation classes and elements
  updatePriceClasses(elements, priceChange) {
    elements.forEach(selector => {
      $(selector).removeClass('rising-price falling-price')
        .addClass(priceChange > 0 || $(selector).hasClass('7879-fee') && $(selector).find('s').length ? 'rising-price' : priceChange < 0 ? 'falling-price' : '');
    });
  },

  // Helper function to get all price elements that need classes
  getPriceElements() {
    const priceClass = '.pdp-main__prices:not(.pdp-upsell__item-prices)';
    return [
      `${priceClass} s`,
      `${priceClass} h3`,
      '.pdp-main__price-breakdown-block.metal-price',
      '.pdp-main__price-breakdown-block.7879-fee',
      '.pdp-main__price-breakdown-block.manufacturing-cost',
      '.pdp-main__price-breakdown-block.save-today',
      '.pdp-main__price-breakdown-block.uk-vat',
      '.pdp-main__brand-comparison__cell.main-brand .pdp-main__brand-comparison__price'
    ];
  },

  // Helper function to update price breakdown values
  updatePriceBreakdownValues(metalValue, storeFee, saveAmount, weight, manufacturingCost, ukVat) {
    $('.pdp-main__price-breakdown-block.weight > p > span').text(weight);
    $('.pdp-main__price-breakdown-block.metal-price > p').text(`${this.currency}${metalValue}`);
    $('.pdp-main__price-breakdown-block.manufacturing-cost > p').text(`${this.currency}${manufacturingCost}`);
    // For bold memberships - if <s> tag in <p>, replace <s> text only, else set <p> text as normal
    const $feeBlock = $('.pdp-main__price-breakdown-block.7879-fee > p');
    if ($feeBlock.find('s').length) {
      $feeBlock.find('s').text(`${this.currency}${storeFee}`);
    } else {
      $feeBlock.text(`${this.currency}${storeFee}`);
    }
    $('.pdp-main__price-breakdown-block.save-today > p').text(`${this.currency}${saveAmount}`);

    // Update UK VAT if provided
    if (ukVat !== undefined) {
      $('.pdp-main__price-breakdown-block.uk-vat > p').text(`${this.currency}${ukVat}`);
    }
  },

  // Helper function to update main price display
  updateMainPriceDisplay(originalPrice, discountedPrice, saveAmount) {
    const priceClass = '.pdp-main__prices:not(.pdp-upsell__item-prices)';
    $(`${priceClass} s`).text(`${this.currency}${originalPrice}`);
    $(`${priceClass} h3`).text(`${this.currency}${discountedPrice}`);
    $(`${priceClass} p`).text(`Save ${this.currency}${saveAmount}`);
    $('.pdp-main__brand-comparison__cell.main-brand .pdp-main__brand-comparison__price').text(`${this.currency}${discountedPrice}`);
  },

  updateMembershipSelectorPriceDisplay(discountedPrice, originalPrice) {
    const currency = this.currency;
    const saveAmount = (originalPrice - discountedPrice).toFixed(2);

    $('.pdp-main__bold-mem-selector-option').each((_, el) => {
      const $option = $(el);
      const isMember = $option.data('type') === 'member';
      $option.find('.pdp-main__bold-mem-selector-option-price span').text(`${currency}${isMember ? discountedPrice : originalPrice}`);
      $option.find('.pdp-main__bold-mem-selector-option-price s').text(`${currency}${originalPrice}`);

      const $saveEl = $option.find('.pdp-main__bold-mem-selector-option-price-info');
      if ($saveEl.length) {
        $saveEl.text($saveEl.data('save-text').replace('[mem_save_amount]', `${currency}${saveAmount}`));
      }
    });

    const $vipPrices = $('.pdp-main__bold-mem-vip-prices');
    if ($vipPrices.length) {
      $vipPrices.find('span').text(`${currency}${discountedPrice}`);
      $vipPrices.find('s').text(`${currency}${originalPrice}`);
    }

    const $vipStoreFee = $('.bold-mem__store-fee');
    if ($vipStoreFee.length && this.customerIsVIP) {
      $vipStoreFee.find('p').text($vipStoreFee.data('store-fee-mem-text').replace('[store_fee]', `${currency}${saveAmount}`));
    }
  },

  // Helper function to store prices for fluctuation comparison
  storePricesForComparison(originalPrice, discountedPrice, metalPrice, storeFee, saveAmount, manufacturingCost, ukVAT) {
    this.previousPrices = {
      compare: originalPrice,
      current: discountedPrice,
      metal: metalPrice,
      storeFee,
      saveAmount,
      manufacturingCost,
      ukVAT
    };
  },

  // Helper function to get metal price with availability check
  getMetalPrice(metal) {
    if (!this.metalPrices) return null;
    return metal === 'platinum' ? this.metalPrices.platinum : metal === 'gold-24k' ? this.metalPrices.gold : null;
  },

  // Helper function to check if price breakdown should be shown
  shouldShowPriceBreakdown() {
    if (!this.metalPrices) return false;

    const $wrapper = $('.pdp-main__price-breakdown-wrapper.conditionalCountry');
    if (!$wrapper.length) return true;

    const display = $wrapper.data('display');
    const allowedCountries = $wrapper.data('country').split(',').map(country => country.trim());
    const currentCountry = $('#customer-country').val();

    return display === 'hide' ? !allowedCountries.includes(currentCountry) : allowedCountries.includes(currentCountry);
  },

  // Helper function to handle price breakdown visibility and fluctuation
  handlePriceBreakdownVisibility(isPreciousMetal) {
    if (!this.metalPrices) {
      $('.pdp-main__price-breakdown-wrapper').addClass('hidden');
      this.managePriceFluctuation(false);
      return;
    }

    const $wrapper = $('.pdp-main__price-breakdown-wrapper');
    $wrapper.not('.conditionalCountry').toggleClass('hidden', !isPreciousMetal);
    $wrapper.filter('.conditionalCountry').toggleClass('hidden', !isPreciousMetal || !this.shouldShowPriceBreakdown());
    this.managePriceFluctuation(isPreciousMetal);
  },

  // Helper function to manage price fluctuation interval
  managePriceFluctuation(isPreciousMetal) {
    if (isPreciousMetal && this.shouldShowPriceBreakdown()) {
      this.startPriceFluctuation();
    } else if (this.priceUpdateInterval) {
      clearInterval(this.priceUpdateInterval);
      this.priceUpdateInterval = null;
    }
  },

  updatePrice() {
    const selectedVar = this.selectedVar;
    if (selectedVar.length) {
      const grossPrice = (selectedVar.data('price') / 100).toFixed(2);
      const metal = selectedVar.data('metal');
      const discountPercent = 30;

      const compareHidden = $('.pdp-main__product-option.metal.active').attr('data-compare-hidden');
      $('.pdp-main__prices:not(.pdp-upsell__item-prices) :is(span:has(s), p)').toggleClass('hidden', this.metal === 'gold-24k' || compareHidden == 'true');

      // Calculate prices based on metal type
      let comparePrice, discountedPrice, mainDiscountedPrice;
      if (FAKE_ALL_METAL_PRICE) {
        discountedPrice = grossPrice;
        comparePrice = (grossPrice * (1 + FAKE_COMPARE_PRICE_PERCENTAGE / 100)).toFixed(2); // Add 12% to get compare price

        if (this.boldMemberships && metal === 'gold-24k') {
          const membershipDiscountPercentage = selectedVar.data('membership-discount-percentage');
          vipDiscountedPrice = (discountedPrice - (discountedPrice * membershipDiscountPercentage / 100)).toFixed(2);

          this.updateMembershipSelectorPriceDisplay(vipDiscountedPrice, discountedPrice);
          if (this.customerIsVIP) {
            $('.pdp-main__prices:not(.pdp-upsell__item-prices) :is(span:has(s), p)').removeClass('hidden');
            mainDiscountedPrice = comparePrice = discountedPrice;
            discountedPrice = vipDiscountedPrice;
          }
        }
      } else if (metal === 'platinum' || metal === 'gold-24k') {
        // For platinum and 24k gold, the price is already discounted
        discountedPrice = grossPrice;
        comparePrice = (grossPrice * (1 + FAKE_COMPARE_PRICE_PERCENTAGE / 100)).toFixed(2); // Add 12% to get compare price
      } else {
        // For other metals, apply 30% discount
        comparePrice = grossPrice;
        discountedPrice = (grossPrice - (grossPrice * discountPercent / 100)).toFixed(2);
      }

      const saveAmount = (comparePrice - discountedPrice).toFixed(2);
      const klarnaPrice = (discountedPrice / Number(this.klarna.data('divide'))).toFixed(2);

      // Handle stock status
      const stock = parseInt(selectedVar.data('stock'));
      const available = !!selectedVar.data('available');
      if (stock <= 0 && !available) {
        $('.pdp-main__atc-btn[data-type="atc"]').addClass('soldout').find('span').text('Sold Out');
      } else {
        const atcMainText = $('.pdp-main__atc-btn[data-type="atc"]').find('span').data('main-text');
        $('.pdp-main__atc-btn[data-type="atc"]').removeClass('soldout').find('span').text(atcMainText);
      }

      if (this.productType !== 'Clothing') {
        // Update main price display
        this.updateMainPriceDisplay(comparePrice, discountedPrice, saveAmount);
        // Reset discountedPrice from VIP display
        if (this.boldMemberships && this.customerIsVIP && metal === 'gold-24k') {
          discountedPrice = mainDiscountedPrice;
        }

        // Calculate metal-related values only if metal prices are available
        if (this.metalPrices) {
          const weight = selectedVar.data('weight');
          const currentMetalPrice = this.getMetalPrice(metal);
          if (currentMetalPrice) {
            // Check if customer is from UK
            const fees = this.isUK() ? this.breakdownPercentages.uk : this.breakdownPercentages.all;

            // Calculate net price and VAT
            // const netPrice = (discountedPrice / (1 + fees.vat)).toFixed(2);
            // const vatAmount = (discountedPrice - netPrice).toFixed(2);
            const vatAmount = (discountedPrice * fees.vat).toFixed(2);

            // Calculate breakdown components
            const metalValue = (discountedPrice * fees.metal).toFixed(2);
            const manufacturingCost = (discountedPrice * fees.manufacturingCost).toFixed(2);
            const storeFee = (discountedPrice * fees.storeFee).toFixed(2);

            log.collapse({
              'metalValue': { value: metalValue, percentage: fees.metal },
              'manufacturingCost': { value: manufacturingCost, percentage: fees.manufacturingCost },
              'storeFee': { value: storeFee, percentage: fees.storeFee },
              'vat': { value: vatAmount, percentage: fees.vat },
              'newDiscountedPrice': { value: discountedPrice, percentage: 100 },
              'newComparePrice': { value: comparePrice, percentage: 140 },
              'total': { value: +discountedPrice - (+metalValue + +vatAmount + +storeFee + +manufacturingCost), percentage: 100 - (fees.metal + fees.manufacturingCost + fees.storeFee + fees.vat) }
            }, 'Initial Values', 'warning');

            // Store prices for comparison
            this.storePricesForComparison(comparePrice, discountedPrice, currentMetalPrice, storeFee, saveAmount, manufacturingCost, vatAmount);

            // Update price breakdown
            this.updatePriceBreakdownValues(metalValue, storeFee, saveAmount, weight, manufacturingCost, vatAmount);

            // Handle price breakdown visibility and fluctuation
            const isPreciousMetal = metal === 'gold-24k'; // TODO: Platinum check removed
            this.handlePriceBreakdownVisibility(isPreciousMetal);
          }
        } else {
          // Hide price breakdown and stop fluctuations if metal prices are not available
          $('.pdp-main__price-breakdown-wrapper').addClass('hidden');
          this.managePriceFluctuation(false);
        }
      } else {
        this.updateMainPriceDisplay(comparePrice, grossPrice, saveAmount);
      }

      if (this.klarna.length > 0) this.klarna.text(`${this.currency}${klarnaPrice}`);
    }
  },

  fluctuateMetalPrice(currentMetalPrice) {
    const fluctuation = (Math.random() * 0.08) - 0.04;
    const newMetalPrice = currentMetalPrice + fluctuation;
    return Number(newMetalPrice.toFixed(2));
  },

  /**
   * @description Update the image srcset based on the metal
   * @param {string} imageSelector - The selector of the image to update
   * @param {string} metal - The metal to update the image to
   */
  updateImageMetalSrcset: window.updateImageMetalSrcset,

  updateMedia(metal) {
    this.updateImages(metal);
    this.updateVideos(metal);
  },
  updateImages(metal) {
    $(`.pdp-main__images .product-images img`).each(function () {
      updateImageMetalSrcset(this, metal);
    });
  },
  updateVideos(metal) {
    const showVariant = ['platinum', 'silver', 'gold-10k-white'].includes(metal) ? 'Silver' : 'Gold';
    $('.pdp-main__images .product-images div[data-type="video"]').each((_, el) => {
      const $el = $(el);
      $el.toggleClass('hidden', $el.data('variant') !== showVariant);
    });
  },


  updateNote(metal) {
    const compareHidden = $('.pdp-main__product-option.metal.active').attr('data-compare');
    $('.pdp-main__price-note').toggleClass(
      'hidden',
      metal === 'gold-24k' || compareHidden == 'true'
    );
  },

  updateDescription() {
    const metalLabel = this.productType === 'Clothing' ? '' : this.getLabel('metal');
    $('.pdp-main__details-content, .pdp-main__product-description').each(function () {
      const $el = $(this);
      const $replaceContent = $el.data('replace-content');
      $el.html($replaceContent.replace('[metal]', metalLabel));
    });
  },

  updatePurityBoard(metal) {
    // Purity Board (The Details faq)
    if (this.productType === 'Clothing' || !metal) return;
    const [baseMetal, karat] = metal.split('-');

    $('.pdp-main__purity-board').hide();
    const $board = $(`.pdp-main__purity-board[data-metal="${baseMetal}"]`).css('display', 'grid');
    if (baseMetal === 'gold') {
      const karatMap = { '24k': 1, '18k': 2, '14k': 3, '9k': 4 };
      const maxIndex = karatMap[karat?.toLowerCase()] || 0;
      $board.find('.pdp-main__purity-item').each((i, el) => {
        $(el).toggleClass('active', i < maxIndex);
      });
    } else if (baseMetal === 'platinum') {
      $board.find('.pdp-main__purity-item').first().addClass('active').siblings().removeClass('active');
    }
  },

  updateSections(metal) {
    // console.log(metal);
    if (metal === 'platinum' || metal === 'gold-24k') {
      $('.shopify-section.image-content-grid:has(.expensive)').show();
      $('.pdp-main__benefit.expensive').show();
    } else {
      $('.shopify-section.image-content-grid:has(.expensive)').hide();
      $('.pdp-main__benefit.expensive').hide();
    }
  },

  updateMetalInfo() {
    if (this.productType === 'Clothing') return;
    const selectedVar = this.selectedVar;
    if (selectedVar.length) {
      const boardMetals = $('.pdp-main__metal-info-board').data('board-metals').toLowerCase();
      const showBoard = boardMetals.includes(this.metal.toLowerCase());
      if (showBoard) {
        const weight = selectedVar.data('weight') || 'N/A';
        let purity = selectedVar.data('purity') || 'N/A';
        // purity = '99.9';
        $('.pdp-main__metal-info-block.purity span').text(purity);
        $('.pdp-main__metal-info-block.weight span').text(weight);
        $('.pdp-main__metal-info-board').show();
      } else {
        $('.pdp-main__metal-info-board').hide();
      }
    }
  },

  updateMadeFY() {
    const selectedVar = this.selectedVar;
    if (selectedVar.length) {
      const stock = Number(selectedVar.data('stock')) || 0;
      const inStock = Boolean(stock > 0 && selectedVar.data('available')) || false;

      const engravingChecked = $('.pdp-main__engraving-option').attr('aria-checked') === 'true';
      const showMadeFY = !inStock || engravingChecked;
      // this.log.table({ ...selectedVar[0].dataset, stockNum: stock, inStock, stockBool: Boolean(stock > 0) }, 'Made FY Stock DATA');

      $(`#variants-data .variant-data[data-metal="${this.metal}"]`).each(function () {
        const variantStock = Number($(this).data('stock')) || 0;
        const variantInStock = Boolean(variantStock > 0 && selectedVar.data('available')) || false;
        const currSize = $(this).data('size');
        const $dropDownItem = $(`.pdp-main__product-options-dropdown__item[data-size="${currSize}"]`);
        $dropDownItem.find('.pdp-main__product-options-dropdown__madefy').toggle(!variantInStock);
      });

      $('.pdp-main__made-fy').toggle(showMadeFY);
      $('.pdp-main__product-delivery, .pdp-main__product-status').toggle(!showMadeFY);
    }
  },

  updateMetalPriceDiagram(metal) {
    const $diagram = $('.pdp-main__metal-price-diagram');
    if (!$diagram.length) return;

    if (metal === 'platinum' || metal === 'gold-24k') {
      $diagram.show();
      const formattedMetal = metal === 'gold-24k' ? 'gold' : metal;
      window.MetalChart.currentMetal = formattedMetal;
      window.MetalChart.updateChart();
    } else {
      $diagram.hide();
    }
  },

  updateInquireButton() {
    const selectedVar = this.selectedVar;
    if (!selectedVar.length) return;
    const price = parseInt(selectedVar.data('price')) / 100;
    const $inquireBtn = $('#inquire-btn');
    if (!$inquireBtn.length) return;
    const INQUIRY_USD_THRESHOLD = $inquireBtn.data('threshold') || 10000; // 10k USD
    const INQUIRY_THRESHOLD_BUFFER = 100; // 100 USD

    const atcBtn = $('.pdp-main__atc-btn[data-type="atc"]');
    const dynamicATCBtn = $('.form.dynamic-checkout-btn');

    // Convert price to USD for comparison
    const priceInDefaultCurrency = price / (window.Shopify?.currency?.rate || 1);
    const usdRate = this.exchangeRates?.conversion_rates?.USD || 1;
    const priceInUSD = priceInDefaultCurrency * usdRate;

    this.log.collapse({
      price,
      exchangeRates: this.exchangeRates,
      ShopifyCurrency: window.Shopify.currency,
      priceInDefaultCurrency,
      usdRate,
      priceInUSD
    }, 'Price Conversion Values', "info");

    if (priceInUSD >= (INQUIRY_USD_THRESHOLD - INQUIRY_THRESHOLD_BUFFER)) {
      $inquireBtn.attr('data-price', '$' + priceInUSD.toFixed(2));
      $inquireBtn.attr('data-metal', $('<div>').text(this.getLabel('metal')).html());
      $inquireBtn.attr('data-size', $('<div>').text(this.getLabel('size')).html());
      $inquireBtn.removeClass('hidden');
      atcBtn.addClass('hidden');
      dynamicATCBtn.addClass('hidden');
    } else {
      $inquireBtn.addClass('hidden');
      atcBtn.removeClass('hidden');
      dynamicATCBtn.removeClass('hidden');
    }
  },

  initUpdate() {
    this.selectVariantFromURL();
    this.updateVariantMetaAndURL();
    this.updateAcceleratedATCForm();
    this.updatePrice();
    this.updateInquireButton();
    this.updateLabel('metal');
    this.updateLabel('size');
    this.updateSizeVariants(this.metal);
    this.updateMedia(this.metal);
    this.updateUpsellMetal(this.metal);
    this.updateSections(this.metal);
    // this.updateNote(this.metal);
    this.updateDescription();
    this.updatePurityBoard(this.metal);
    this.updateMetalPriceDiagram(this.metal);
    this.updateBoldMembershipComponents(this.metal);
    this.updateMetalInfo();
    this.updateMadeFY();
    this.updateDynamicCheckoutDisabled(false);
  },

  boldMembershipsSelector() {
    const $boldMembershipsSelector = $('.pdp-main__bold-mem-selector');
    if (!$boldMembershipsSelector.length) return;

    $boldMembershipsSelector.find('.pdp-main__bold-mem-selector-option').on('click', (e) => {
      const $option = $(e.currentTarget);
      $('.pdp-main__bold-mem-selector-option').removeClass('active');
      $option.toggleClass('active');
      this.updateBoldMembershipComponents(this.metal);
    });
  },

  updateBoldMembershipComponents(metal) {
    $('.pdp-main__bold-mem-vip, .pdp-main__bold-mem-selector').toggleClass('hidden', metal !== 'gold-24k');

    const $memberOption = $('.pdp-main__bold-mem-selector-option[data-type="member"]');
    if ($memberOption.length) {
      const isMemberSelected = $memberOption.hasClass('active');
      $('.pdp-main__atc-btn[data-type="atc"]').toggleClass('bold-membership', metal == 'gold-24k' && isMemberSelected);
    }
  },

  updateSizeVariants(metal) {
    const $sizeVariants = $('.pdp-main__product-option.size, .pdp-main__product-options-dropdown__item');
    const existingSizeVariants = $('.variant-data[data-metal="' + metal + '"]').map((i, el) => $(el).data('size')).get();
    if (!existingSizeVariants.length || !$sizeVariants.length) return;
    $sizeVariants.each((i, el) => {
      const $el = $(el);
      const shouldShow = existingSizeVariants.includes($el.data('size'));
      $el.toggle(shouldShow);
      if ($el.hasClass('active') && !shouldShow) {
        $sizeVariants.filter((i, el) => existingSizeVariants.includes($(el).data('size'))).first().trigger('click');
      }
    });
  },

  variantSelector() {
    $('.pdp-main__product-option').on('click', (e) => {
      const $option = $(e.currentTarget);
      const group = $option.data('metal') ? 'metal' : 'size';

      $option.addClass('active').siblings(`.${group}`).removeClass('active');
      this[group] = $option.data(group);

      if (group === 'metal') {
        this.updateSizeVariants(this.metal);
        this.updateMedia(this.metal);
        this.updateSections(this.metal);
        // this.updateNote(this.metal);
        this.updateDescription();
        this.updatePurityBoard(this.metal);
        this.updateMetalPriceDiagram(this.metal);
        this.updateBoldMembershipComponents(this.metal);
        this.updatePriceClasses(this.getPriceElements(), this.metal === 'gold-24k' ? 1 : 0);
        this.updateUpsellMetal(this.metal);
      }
      this.updatePrice();
      this.updateInquireButton();
      this.updateLabel(group);
      this.updateMetalInfo();
      this.updateMadeFY();
      this.updateVariantMetaAndURL();
      this.updateAcceleratedATCForm();
    });


    $('.pdp-main__product-options-dropdown__item').on('click', (e) => {
      const $item = $(e.currentTarget);
      if (!$item.is('[data-selected="true"]')) {
        $('.pdp-main__product-options-dropdown__item[data-selected="true"]').removeAttr('data-selected');
        $item.attr('data-selected', 'true');
        $('.pdp-main__product-options-dropdown').removeClass('open');
      }
      this.handleSizeVariantChange($item.data('size'));
    });

  },

  // Handle variant change logic
  handleSizeVariantChange(selectedValue) {
    this.size = selectedValue;
    this.updateVariantMetaAndURL();
    this.updatePrice();
    this.updateLabel('size');
    this.updateMetalInfo();
    this.updateMadeFY();
    this.updateInquireButton();
  },

  updateAcceleratedATCForm() {
    const selectedVar = this.selectedVar;
    const id = selectedVar.data('id');
    if (!id) return;
    $('form input.product-variant-id').val(id);
  },

  selectVariantFromURL() {
    const variantId = new URLSearchParams(window.location.search).get('variant');
    if (!variantId) return;
    const $variant = $(`#variants-data .variant-data[data-id="${variantId}"]`);
    if (!$variant.length) return;

    if (this.productType === 'Clothing') {
      this.size = $variant.data('metal') || this.size;
    } else {
      this.metal = $variant.data('metal') || this.metal;
      this.size = $variant.data('size') || this.size;
    }

    if (this.metal) {
      $(`.pdp-main__product-option[data-metal="${this.metal}"]`).addClass('active').siblings('.metal').removeClass('active');
    }

    if (this.size) {
      // Handle dropdown if present
      const $dropdownRadio = $(`.pdp-main__product-options-dropdown__radio[value="${this.size}"]`);
      if ($dropdownRadio.length) {
        $dropdownRadio.prop('checked', true).trigger('change');
      } else {
        $(`.pdp-main__product-option[data-size="${this.size}"]`).addClass('active').siblings('.size').removeClass('active');
      }
    }
  },

  updateVariantMetaAndURL() {
    const selectedVar = this.selectedVar;
    if (!selectedVar.length) return;

    // const variantId = selectedVar.data('id');
    if (this.productType !== 'Clothing' && !this.metal || this.productType === 'Clothing' && !this.size) return;

    const url = new URL(window.location.href);
    const canonicalUrl = new URL(url.href); // Copy for canonical to keep rest of params in url
    canonicalUrl.search = '';

    if (this.productType !== 'Clothing') {
      const variantMetals = $(`#variants-data .variant-data[data-metal="${this.metal}"]`);
      const firstVariantId = variantMetals.first().data('id');
      url.searchParams.set('variant', firstVariantId);
      url.searchParams.set('metal', this.metal);
      canonicalUrl.searchParams.set('variant', firstVariantId);
      canonicalUrl.searchParams.set('metal', this.metal);
    }

    $('link[rel="canonical"]').attr('href', canonicalUrl.href);

    // Update the page title dynamically
    const titlePrefix = 'Shop';
    const titleSuffix = ' | 7879';
    let baseTitle = document.title.split(titleSuffix)[0].split(' - ')[0];
    baseTitle = baseTitle.includes(titlePrefix) ? baseTitle.split(titlePrefix)[1] : baseTitle;
    const newTitle = this.productType === 'Clothing' ? `${titlePrefix} ${baseTitle}${titleSuffix}` : `${titlePrefix} ${baseTitle} - ${selectedVar.text()}${titleSuffix}`;
    document.title = newTitle;

    // Update the meta description dynamically
    if (this.productType !== 'Clothing') {
      const descriptionPrefix = `${selectedVar.text()} ${baseTitle}`;
      const descriptionSuffix = 'Track Value Based On Real Time Prices ✓ Hypoallergenic & Anti-microbial ✓ Sustainably Sourced ✓ Sell Back OR Exchange';

      // console.table(descriptionPrefix, descriptionSuffix)
      // const baseDescription = $('meta[name="description"]').attr('content').split(' - ')[1] || $('meta[name="description"]').attr('content');
      $('meta[name="description"]').attr('content', `${descriptionPrefix}. ${descriptionSuffix}`);
    }
    // Push new state to browser history
    window.history.replaceState({}, '', url.href);
  },

  handlePopupUpsell(selectedVar, mainItems = null) {
    const popup = $('.popup-upsell');
    const upsellAtcButton = popup.find('.popup-upsell__atc-btn');
    const originalId = selectedVar.data('id');
    const totalPrice = (Number(selectedVar.data('price')) + Number(upsellAtcButton.data('price'))) / 100;

    popup.find('.popup-upsell__atc-price').text(`${this.currency}${totalPrice.toFixed(2)}`);
    popup.addClass('active');

    // Start the timer if it exists
    if (window.popupUpsellTimer) window.popupUpsellTimer.start();

    const closePopupAndAddToCart = (items) => {
      if (window.popupUpsellTimer) window.popupUpsellTimer.stop();
      const finalItems = mainItems || items;
      $.post('/cart/add.js', { items: finalItems })
        .done(() => {
          upsellAtcButton.removeClass('loading');
          popup.removeClass('active');
          window.cart_open();
          window.cart_build();
        })
        .fail(() => alert('Error adding items to cart.'));
    };

    // Remove any existing click handlers
    upsellAtcButton.off('click');
    popup.find('.popup-upsell__decline').off('click');

    upsellAtcButton.on('click', () => {
      upsellAtcButton.addClass('loading');
      const items = [...(mainItems || [{ id: originalId, quantity: 1 }]), { id: upsellAtcButton.data('id'), quantity: 1 }];
      closePopupAndAddToCart(items);
    });

    popup.find('.popup-upsell__decline').on('click', () => {
      closePopupAndAddToCart(mainItems || [{ id: originalId, quantity: 1 }]);
    });
  },

  addToCart() {
    const $modal = $('#bold-memberships-selector-modal');
    // Remove existing handlers
    $('.pdp-main__atc-btn[data-type="atc"]').off('click.addToCart');
    // Bind single handler for all ATC buttons
    $('.pdp-main__atc-btn[data-type="atc"]').on('click.addToCart', (e) => {
      if (e.currentTarget) e.preventDefault();
      const $atcButton = $(e.currentTarget);
      const isMembership = $atcButton.hasClass('bold-membership') && this.boldMemberships;

      const selectedVar = this.selectedVar;
      const id = selectedVar.data('id');
      if (!id) return alert('Please select a product option.');

      // Check engraving validation
      const $engravingOption = $('.pdp-main__engraving-option');
      const $engravingInput = $('.pdp-main__engraving-input');
      if ($engravingOption.attr('aria-checked') === 'true' && !$engravingInput.val().trim()) {
        $engravingInput.addClass('error').focus();
        this.showEngravingError('Please enter engraving text');
        return;
      }

      $atcButton.addClass('loading');

      // Get engraving properties
      const engravingProps = this.useEngraving();
      const engravingId = $('.pdp-main__engraving').data('engraving-id');

      // Prepare cart items
      const items = [{ id, quantity: 1 }];

      if (engravingProps && engravingId) {
        const sku = selectedVar.data('sku') || `variant-${id}`;
        const sharedId = this.generateSharedId(sku, engravingProps.Engraving);

        items[0].properties = { ...engravingProps, '_Engraving Link ID': sharedId };
        items.push({
          id: engravingId,
          quantity: 1,
          properties: { '_Engraving Link ID': sharedId, '_Linked Product SKU': sku }
        });
      }

      $atcButton.hasClass('popup-upsell__trigger')
        ? this.handlePopupUpsell(selectedVar, items)
        : $.post('/cart/add.js', { items })
          .done(() => {
            $atcButton.removeClass('loading');
            if (isMembership && $modal.length) {
              $modal.data('scroll-position', window.pageYOffset || document.documentElement.scrollTop);
              $modal.addClass('active').removeAttr('inert');
              $('body').addClass('no-scroll');
              $('#MainContent').css('z-index', '99999');
              if ($('.modal-wrapper.active').length > 1) $modal.find('.modal-overlay').css('background', '#00000005');
            } else {
              window.cart_open();
            }
            window.cart_build();
          })
          .fail(() => alert('Error adding item to cart.'));
    });

    // Bind close handler once per modal
    if (this.boldMemberships && $modal.length && !$modal.data('modal-close-bound')) {
      $modal.on('click.addToCart', '.modal-close, .modal-overlay', function () {
        const savedScrollPosition = $modal.data('scroll-position') || 0;
        $modal.removeClass('active').attr('inert', 'true');
        $modal.find('.modal-overlay').css('background', '');
        if (!$('.modal-wrapper.active').length) {
          $('body').removeClass('no-scroll');
          $('#MainContent').css('z-index', 'unset');
          setTimeout(() => window.scrollTo(0, savedScrollPosition), 10);
        }
      });
      $modal.data('modal-close-bound', true);
    }
  },

  updateUpsellMetal(metal) {
    $(`.pdp-upsell__item-footer .main-select[data-type="metal"]`).find(`.main-select__item[data-metal="${metal}"]`).click();
  },

  // ===================== Engraving (compact) =====================
  engraving() {
    const $wrap = $('.pdp-main__engraving');
    if (!$wrap.length) return;
    const $toggle = $wrap.find('.pdp-main__engraving-option');
    const $panel = $wrap.find('.pdp-main__engraving-input-container');
    const $input = $wrap.find('.pdp-main__engraving-input');
    const max = Number($wrap.data('max-chars')) || 12;
    const allowKey = /^[a-zA-Z0-9\s\-_.;@?!#'"()&]$/;
    const cleanRe = /[^a-zA-Z0-9\s\-_.;@?!#'"()&]/g;

    const updateCount = () => {
      const current = ($input.val() || '').length;
      $wrap.find('[data-char-count]').text(`${current}/${max}`);
    };
    const cleanInput = () => {
      const cleaned = ($input.val() || '').replace(cleanRe, '').slice(0, max);
      if ($input.val() !== cleaned) $input.val(cleaned);
      updateCount();
      const valid = cleaned.length === 0 || /^[a-zA-Z0-9\s\-_.;@?!#'"()&]+$/.test(cleaned);
      $input.toggleClass('error', !valid);

      // Hide error if user enters text
      if (cleaned.trim()) this.hideEngravingError();
      this.updateDynamicCheckoutDisabled(cleaned.trim().length > 0);
    };

    // If option should always be expanded—set, expand, update MFY, lock toggle event
    const alwaysExpanded = $toggle.hasClass('pdp-main__engraving-option--always-expanded');
    if (alwaysExpanded) {
      $toggle.attr('aria-checked', 'true');
      $panel.show();
      this.hideEngravingError();
      this.updateMadeFY();
      this.updateDynamicCheckoutDisabled(true);
    } else {
      $toggle.on('click keydown', (e) => {
        if (e.type === 'keydown' && !(e.key === ' ' || e.key === 'Enter')) return;
        e.preventDefault();
        const checked = $toggle.attr('aria-checked') === 'true';
        $toggle.attr('aria-checked', checked ? 'false' : 'true');
        this.updateMadeFY();
        checked ? $panel.slideUp(200) : $panel.slideDown(200, () => $input.trigger('focus'));
        if (!checked) {
          this.hideEngravingError();
          this.updateDynamicCheckoutDisabled(true);
          return;
        }
        $input.val('');
        updateCount();
        $input.removeClass('error');
        this.updateDynamicCheckoutDisabled(false);
      });
    }

    $input.on('keypress', (e) => { if (!allowKey.test(e.key)) e.preventDefault(); cleanInput(); });
    $input.on('input paste', () => cleanInput());

    updateCount();
  },

  useEngraving() {
    const $option = $('.pdp-main__engraving-option');
    const $input = $('.pdp-main__engraving-input');

    const isChecked = $option.attr('aria-checked') === 'true';
    const engravingText = $input.val()?.trim();

    if (!isChecked || !engravingText) return null;

    // Validate before returning (compact check)
    if (!/^[a-zA-Z0-9\s\-_.;@?!#'"()&]+$/.test(engravingText)) {
      console.warn('Invalid engraving text:', engravingText);
      return null;
    }

    return { Engraving: engravingText };
  },

  generateSharedId(sku, engravingText) {
    const timestamp = Date.now().toString(36);
    const skuHash = this.simpleHash(sku);
    const engravingHash = this.simpleHash(engravingText);
    return `${skuHash}-${engravingHash}-${timestamp}`;
  },

  simpleHash(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }
    return Math.abs(hash).toString(36).substring(0, 6);
  },

  showEngravingError(message) {
    const $container = $('.pdp-main__engraving-input-container');
    $container.find('.engraving-error').remove();
    $container.append(`<div class="engraving-error">${message}</div>`);
  },

  hideEngravingError() {
    $('.pdp-main__engraving-input').removeClass('error');
    $('.engraving-error').remove();
  },

  updateDynamicCheckoutDisabled(shouldDisable) {
    const $engravingOption = $('.pdp-main__engraving-option');
    const isChecked = $engravingOption.attr('aria-checked') === 'true';

    // Disable dynamic checkout when engraving is enabled
    this.log(isChecked, shouldDisable, 'isChecked, shouldDisable');
    if (isChecked || shouldDisable) {
      $('shopify-accelerated-checkout').prop('disabled', true);
    } else {
      $('shopify-accelerated-checkout').prop('disabled', false);
    }
  }

};

$(document).ready(function () {
  Product.init();
});